export default __webpack_public_path__ + "static/logo-grey-2ce5154dcf072fed6dfadc61d075401a.svg";